import Cohere from 'cohere-js';

const identifyUser = (user: any) => {
  Cohere.identify(user.uuid, {
    email: user.email,
    displayName: user.name || user.email,
  });
};

const apiKey = process.env.COHERE_API_KEY;
if (apiKey) {
  Cohere.init(apiKey);
}

const CohereHelper = {
  identifyUser,
};

export default CohereHelper;
